module.exports = __webpack_public_path__ + "static/img/20230710_04.fe22d1a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2023/20230710_04.png
// module id = N6Bn
// module chunks = 0